import axios from 'axios'
import { CADASTRAR_ENCOMENDA_AVULSA_SICOOB } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions'

// cria a encomenda avulsa e já gera a cobrança PIX Sicoob, igual a pagarPedidoSicoob (passagem)
export default function cadastrarEncomendaAvulsaSicoob (comando) {
  const url = `${URL}/encomendas-avulsas/cadastrar/terminal-venda-sicoob`
  return dispatch => axios.post(url, comando, SLOW_REQUEST_CONFIG).then(
    response => dispatch({
      type: CADASTRAR_ENCOMENDA_AVULSA_SICOOB,
      payload: response
    })
  )
}
